import { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot, where } from 'firebase/firestore';
import { db } from '../firebase.js';
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

const useDashboardData = (user) => {
    const [data, setData] = useState({
        agreements: [],
        transactions: [],
        withdrawals: [],
        teamData: null,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!user?.uid) {
            setLoading(false);
            return;
        }

        setLoading(true);
        const unsubscribes = [];
        let initialLoads = 4; // agreements, transactions, withdrawals, teamData

        const checkDone = () => {
            initialLoads--;
            if (initialLoads === 0) setLoading(false);
        };

        const agQuery = query(collection(db, `users/${user.uid}/agreements`), orderBy('createdAt', 'desc'));
        unsubscribes.push(onSnapshot(agQuery, (snap) => { setData(prev => ({ ...prev, agreements: snap.docs.map(d => ({ id: d.id, ...d.data() })) })); checkDone(); }, (err) => { setError(err.message); setLoading(false); }));

        const txQuery = query(collection(db, `users/${user.uid}/balance_transactions`), orderBy('createdAt', 'desc'));
        unsubscribes.push(onSnapshot(txQuery, (snap) => { setData(prev => ({ ...prev, transactions: snap.docs.map(d => ({ id: d.id, ...d.data() })) })); checkDone(); }, (err) => { setError(err.message); setLoading(false); }));

        const withdrawQuery = query(collection(db, 'withdraw_requests'), where('userId', '==', user.uid), orderBy('createdAt', 'desc'));
        unsubscribes.push(onSnapshot(withdrawQuery, (snap) => { setData(prev => ({ ...prev, withdrawals: snap.docs.map(d => ({ id: d.id, ...d.data() })) })); checkDone(); }, (err) => { setError(err.message); setLoading(false); }));

        const getTeamData = httpsCallable(functions, 'api');
        getTeamData({ __fn: 'getTeamData' })
            .then(result => { setData(prev => ({ ...prev, teamData: result.data })); checkDone(); })
            .catch(err => { setError(err.message); setLoading(false); });

        return () => unsubscribes.forEach(unsub => unsub());
    }, [user]);

    return { ...data, loading, error };
};

export default useDashboardData;